import React from 'react';

const Header = () => {
  return (
    <>
      <h1>  Wellness Survey </h1>
      <p> Let&apos;s talk about your health.
      Please fill out this quick form and we will help you find answers.
      This is how it works:
      We are never going to share your information.
      We will get back to you with tailored solutions for your health concerns using our food
      combination method within 7 days.
      We will keep you updated on health news, perks and information in our community
      And we will make you a believer in Food4Cure!
      </p>
    </>
  )
};
/* tabIndex="0"> */
export default Header